import { ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { addReactError } from '@datadog/browser-rum-react';
import { ErrorScreen404 } from 'components/error-screen-404';

interface ErrorBoundaryProps {
  children: ReactNode;
}

const ErrorBoundary = (props: ErrorBoundaryProps) => {
  const { children } = props;

  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorScreen404}
      onError={(error, { componentStack }) => {
        addReactError(error as Error, { componentStack });
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
};

export { ErrorBoundary };
